module.exports = __webpack_public_path__ + "media/images/flags/16/San-Marino-07d6c2c1d07abd428ee041dbc5ebc61f.png";